import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { trans } from "../../../helpers/index";
import config from "../../../baseConfig/index";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import Modal from "../../Fragments/Modal";
import ErrorModal from "../../Fragments/ErrorModal";
import { EyeComponent } from "../../UIComponents/UIComponents";
import SimpleCrypto from "simple-crypto-js";
import { withCookies } from "react-cookie";

class MobStepThree extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonDisabled: false,
      formResponse: "",
      password: "",
      passwordConfirmation: "",
      passwordMaxLength: 8,
      successModal: false,
      showErrorModal: false,
      isShowPassword: false,
      isShowRepeatPassword: false,
      userName: this.props.forgotConfig.userName,
    };

    this.goToLoginPage = this.goToLoginPage.bind(this);
    this.signIn = this.signIn.bind(this);
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      isShowPassword: !prevState.isShowPassword,
    }));
  };

  toggleRepeatPasswordVisibility = () => {
    this.setState((prevState) => ({
      isShowRepeatPassword: !prevState.isShowRepeatPassword,
    }));
  };

  goToLoginPage() {
    this.props.setLoginAction(this.props.forgotConfig.userName);
    this.props.history.push(config.urlPrefix);
  }

  successModal() {
    if (!this.state.successModal) {
      return "";
    }

    return (
      <Modal
        title={trans(this.props.trans, "auth.forgot.password.success.title")}
        description={trans(
          this.props.trans,
          "auth.forgot.password.success.description"
        )}
        agreeText={trans(
          this.props.trans,
          "auth.forgot.password.success.agree"
        )}
        agreeAction={this.signIn}
      />
    );
  }

  sendData(event) {
    this.setState({ buttonDisabled: true });

    ApiManager.postRequest(
      {
        password: this.state.password,
        password_confirmation: this.state.passwordConfirmation,
        token: this.props.forgotConfig.token,
        _token: this.props.csrf_token.data,
      },
      "/forgot-password/mob/set-password"
    ).then(
      (resolve) => {
        this.setState({
          buttonDisabled: false,
          formResponse: resolve.data,
        });

        if (resolve.data.status === "OK") {
          this.setState({ successModal: true });
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );

    event.preventDefault();
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  initLogoutTimer() {
    setTimeout(() => {
      this.props.cookies.remove("loginToken");
      this.props.history.push(config.urlPrefix);
    }, config.logoutTimer);
  }

  signIn() {
    ApiManager.postRequest(
      {
        username: this.props.forgotConfig.userName,
        password: this.state.password,
        _token: this.props.csrf_token.data,
      },
      "/login"
    ).then(
      (resolve) => {
        if (resolve.data.status === "OK") {
          let simpleCrypto = new SimpleCrypto(config.simpleCryptoSecretKey);
          this.props.cookies.set(
            "loginToken",
            simpleCrypto.encrypt(resolve.data.jwt),
            { path: config.urlPrefix }
          );
          this.props.history.push(config.urlPrefix + "profile");
          this.initLogoutTimer();
        } else {
          this.props.history.push(config.urlPrefix);
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  render() {
    let passwordsCountIsValid =
        this.state.password.length >= this.state.passwordMaxLength &&
        this.state.passwordConfirmation.length >= this.state.passwordMaxLength,
      errorPasswordClass = "",
      errorPasswordBox = "",
      errorPasswordConfirmationClass = "",
      errorPasswordConfirmationBox = "",
      errorBox = "";

    if (this.state.formResponse !== "") {
      if (this.state.formResponse.status === "INVALID_DATA") {
        if (this.state.formResponse.errors.hasOwnProperty("password")) {
          errorPasswordClass = " form-error";
          errorPasswordBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.password}
            </div>
          );
        }

        if (
          this.state.formResponse.errors.hasOwnProperty("password_confirmation")
        ) {
          errorPasswordConfirmationClass = " form-error";
          errorPasswordConfirmationBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.password_confirmation}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("token")) {
          errorBox = (
            <FormMiddlewareError
              message={this.state.formResponse.errors.token}
            />
          );
        }
      }

      if (this.state.formResponse.status === "ERROR") {
        errorBox = (
          <FormMiddlewareError
            message={this.state.formResponse.message}
            trans={this.props.trans}
          />
        );
      }
    }

    return (
      <div className="form">
        <form
          action="#"
          method="post"
          onSubmit={(event) => this.sendData(event)}
        >
          <div className="form__form-box">
            <label className="form__label db fs11" htmlFor="tel-number">
              {trans(
                this.props.trans,
                "auth.forgot.password.mob.set.password.label1"
              )}
            </label>
            <div className="form__field-out">
              <input
                className="form__field fs13"
                id="tel-number"
                name="tel-number"
                type="text"
                disabled="disabled"
                value={this.props.forgotConfig.userName}
              />
            </div>
          </div>

          <div className={`form__form-box${errorPasswordClass}`}>
            <label className="form__label db fs11" htmlFor="password">
              {trans(
                this.props.trans,
                "auth.forgot.password.mob.set.password.label2"
              )}
            </label>
            <div className="form__field-out" style={{ position: "relative" }}>
              <input
                type="text"
                name="fake-user"
                autoComplete="password-forgot"
                style={{ display: "none" }}
                onChange={() => {}}
                value=""
              />
              <input
                className="form__field fs13"
                id="password"
                name="new-password" // Renamed to avoid matching common 'password' fields
                type={this.state.isShowPassword ? "text" : "password"}
                value={this.state.password}
                autoComplete="new-password" // Suggests to the browser this is for a "new" password
                onChange={(event) => {
                  this.setState({
                    password: event.target.value.trim(),
                  });
                }}
              />
              <EyeComponent
                isShow={this.state.isShowPassword}
                eyeHandler={this.togglePasswordVisibility}
              />
            </div>
            {errorPasswordBox}
            <div className="form__details-txt fs11">
              {trans(
                this.props.trans,
                "auth.forgot.password.mob.set.password.note"
              )}
            </div>
          </div>

          <div className={`form__form-box${errorPasswordConfirmationClass}`}>
            <label
              className="form__label db fs11"
              htmlFor="password_confirmation"
            >
              {trans(
                this.props.trans,
                "auth.forgot.password.mob.set.password.label3"
              )}
            </label>
            <div className="form__field-out" style={{ position: "relative" }}>
              <input
                type="text"
                name="fake-user"
                autoComplete="username"
                style={{ display: "none" }}
                onChange={() => {}}
                value=""
              />
              <input
                className="form__field fs13"
                id="password_confirmation"
                name="password_confirmation"
                type={this.state.isShowRepeatPassword ? "text" : "password"}
                value={this.state.passwordConfirmation}
                onChange={(event) => {
                  this.setState({
                    passwordConfirmation: event.target.value.trim(),
                  });
                }}
              />
              <EyeComponent
                isShow={this.state.isShowRepeatPassword}
                eyeHandler={this.toggleRepeatPasswordVisibility}
              />
            </div>
            {errorPasswordConfirmationBox}
          </div>

          {errorBox}

          <button
            className={`form__registration-btn btn btn--yellow fs17${
              this.state.buttonDisabled ? " btn--loading" : ""
            }`}
            type="submit"
            disabled={!passwordsCountIsValid || this.state.buttonDisabled}
          >
            {trans(
              this.props.trans,
              "auth.forgot.password.mob.set.password.button.title"
            )}
          </button>
        </form>
        {this.successModal()}
        {this.errorModal()}
      </div>
    );
  }
}

export default withRouter(withCookies(MobStepThree));
